let messages =
{
  button: {
    ok: 'Ok',
    continue: 'Continue',
    cancel: 'Cancel',
    yes: 'Yes',
    no: 'No',
    create: 'Create',
    save: 'Save',
    close: 'Close',
    delete: 'Delete',
    send: 'Send',
    add: 'Add',
    remove: 'Remove',
    search: 'Search',
    reset: 'Reset',
    report: 'Report',
    media: {
      excel: 'Excel'
    },
    showSource: 'Show source',
    showFormatted: 'Show formatted'
  },
  boolean: {
    true: 'Yes',
    false: 'No'
  },
  filter: 'Filter',
  language: {
    en: 'English',
    da: 'Danish'
  },
  subscription: {
    none: 'None',
    paid: 'Paid',
    unpaid: 'Unpaid',
    cancelled: 'Cancelled'
  },
  userRoles: {
    ADMIN: 'Administrator',
    MEMBER_VIEW: 'View members',
    MEMBER_EDIT: 'Edit members',
    MEMBER_ACCOUNTING: 'Edit member subscriptions'
  },
  header: {
    logout: 'Logout',
    button: {
      endImpersonation: 'End impersonation'
    },
    dialog: {
      preferences: {
        header: 'Preferences',
        language: 'Language'
      }
    }
  },
  sidebar: {
    dashboard: 'Dashboard',
    members: 'Members',
    users: 'Users',
    organizations: 'Organizations',
    configuration: 'Configuration'
  },
  pages: {
    login: {
      button: {
        login: 'Login',
        changePassword: 'Change password'
      },
      link: {
        forgotPassword: 'Forgot password'
      },
      newPasswordMessage: 'Please enter a new password',
      dialog: {
        forgotPassword: {
          header: 'Forgot password',
          message: 'User name',
          button: {
            send: 'Send new password'
          },
          error: {
            notFound: 'User \'{userName}\' was not found'
          }
        }
      }
    },
    dashboard: {
      welcomeMessage: 'Welcome to Calasdo'
    },
    organization: {
      button: {
        create: 'Create new organization'
      },
      table: {
        columns: {
          name: 'Name',
          domainName: 'Domain name'
        }
      },
      edit: {
        header: {
          create: 'New organization',
          update: 'Edit organization'
        },
        fields: {
          name: 'Name',
          domainName: 'Domain name'
        }
      },
      dialog: {
        delete: {
          header: 'Delete organization',
          message: 'Are you sure you want to delete \'{name}\'?'
        }
      }
    },
    user: {
      button: {
        create: 'Create new user',
        resetPassword: 'Reset password',
        impersonate: 'Impersonate'
      },
      snackbar: {
        resetPassword: {
          succeed: 'Password has been reset',
          failed: 'Failed to reset password'
        }
      },
      table: {
        columns: {
          userName: 'User name',
          fullName: 'Full name',
          email: 'E-mail',
          superAdmin: 'Super administrator',
          organization: 'Organization',
          roles: 'Roles'
        }
      },
      edit: {
        header: {
          create: 'New user',
          update: 'Edit user'
        },
        fields: {
          userName: 'User name',
          fullName: 'Full name',
          email: 'E-mail',
          superAdmin: 'Super administrator',
          organization: 'Organization',
          roles: 'Roles'
        },
        error: {
          inUse: 'User name \'{userName}\' already exists'
        }
      },
      dialog: {
        resetPassword: {
          header: 'Reset password',
          message: 'Are you sure you want to reset the password for \'{userName}\'?'
        },
        delete: {
          header: 'Delete user',
          message: 'Are you sure you want to delete \'{userName}\'?'
        }
      }
    },
    configuration: {
      tabs: {
        global: {
          tabName: 'Global configuration',
          intro: 'This is the global configuration, which is still empty'
        },
        mail: {
          tabName: 'Mail',
          server: {
            header: 'Mail server',
            hostName: 'Host name',
            port: 'Port no.',
            userName: 'User name',
            password: 'Password'
          },
          sender: {
            header: 'Sender / from',
            name: 'Name',
            email: 'Email address'
          }
        },
        mailTemplate: {
          tabName: 'Mail templates',
          template: 'Template',
          subject: 'Subject',
          templates: {
            welcome: 'Welcome',
            resetPassword: 'Reset password',
            forgotPassword: 'Forgot password'
          }
        }
      }
    },
    member: {
      button: {
        openSearch: 'Advanced search',
        showAll: 'Show all',
        create: 'Add new member',
        addSubscription: 'Add subscription',
        paid: 'Paid',
        print: 'Print',
        sendEmail: 'Send email',
        copyEmailAddresses: 'Copy email addresses'
      },
      snackbar: {
        copyEmailAddresses: {
          succeed: 'Email addresses copied to clipboard'
        }
      },
      type: {
        private: 'Private',
        company: 'Company',
        association: 'Association'
      },
      table: {
        columns: {
          number: 'No.',
          name: 'Name',
          address: 'Address',
          phone: 'Phone',
          email: 'Email',
          subscription: 'Subscription'
        }
      },
      search: {
        header: 'Search members',
        fields: {
          number: 'Number',
          firstName: 'First name',
          type: 'Type',
          supportMember: 'Support member',
          middleName: 'Middle name',
          lastName: 'Last name',
          companyName: 'Company name',
          vat: 'VAT no.',
          associationName: 'Association',
          email: 'Email',
          phone: 'Phone',
          mobile: 'Mobile',
          address: 'Address',
          location: 'Location',
          zipCode: 'Zip code',
          city: 'City',
          country: 'Country'
        }
      },
      edit: {
        header: {
          create: 'Add new member',
          update: 'Edit member'
        },
        fields: {
          number: 'Number',
          firstName: 'First name',
          type: 'Type',
          supportMember: 'Support member',
          middleName: 'Middle name',
          lastName: 'Last name',
          companyName: 'Company name',
          vat: 'VAT no.',
          associationName: 'Association',
          email: 'Email',
          phone: 'Phone',
          mobile: 'Mobile',
          address: 'Address',
          location: 'Location',
          zipCode: 'Zip code',
          city: 'City',
          country: 'Country',
          comments: 'Comments',
          subscriptions: 'Subscriptions'
        }
      },
      subscription: {
        table: {
          columns: {
            created: 'Created',
            text: 'Text',
            status: 'Status'
          }
        }
      },
      dialog: {
        delete: {
          header: 'Delete member',
          message: 'Are you sure you want to delete \'{name}\'?'
        },
        createSubscription: {
          header: 'Create subscription',
          text: 'Text'
        },
        editSubscription: {
          header: 'Edit subscription',
          text: 'Text',
          paid: 'Paid',
          cancelled: 'Cancelled'
        }
      }
    }
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/plugins/i18n/en.js